var IsMiniBoardObject = function (object) {
    return (object.type === 'rexMiniBoard');
};

export default IsMiniBoardObject;